<template>
	<div>

		<div v-if="init">
	
			<div class="my-6 flex items-center">
				<!-- <router-link :to="{name: 'marktime-list'}" class="mr-2 btn">
					Back
				</router-link> -->
				<button @click="updateMarktime" class="mr-2 btn btn-secondary">
					<div v-if="updating" class="loader"></div>
	                <span v-else>Update</span>
				</button>
				<router-link :to="{name: 'preview', params: {id: key}}" target="_blank" class="mr-2 btn btn-info">
					Preview
				</router-link>
			</div>
	
			<div class="flex">
				<div class="mr-6">
					<MarktimeTable :marktime="marktime" :setup="setup"></MarktimeTable>
				</div>
				<div class="">
					<MarktimeTableOverview :marktime="marktime"></MarktimeTableOverview>
				</div>
			</div>
		</div>

		<div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>

		<SimpleModal v-if="unsavedModal" @action="updateMarktime" @close="$store.commit('SET_UNSAVED_MODAL', false)" :btnClass="'btn-secondary'">
            <template v-slot:title>Unsaved changes</template>
            <template v-slot:body>You have unsaved changes!</template>
            <template v-slot:cancel>Close</template>
            <template v-slot:button>Save</template>
			<template v-slot:customButton>
                <button class="btn btn-info ml-4" @click="discardChanges">
                    Discard changes
                </button>
            </template>
        </SimpleModal>

	</div>
</template>

<script>
import moment from "moment"
import { db } from "@/firebase"
import helper from '../../helpers'
import store from '@/store/store'
import { mapState } from 'vuex'

import MarktimeTable from "@/components/MarktimeTable.vue"
import MarktimeTableOverview from "@/components/MarktimeTableOverview.vue"
import SimpleModal from '@/components/SimpleModal.vue'

export default {

	data() {
		return {
			marktime: null,
			key: this.$route.params.id,
			updating: false
		}
	},

	computed: {
		init() {
			if (this.marktime) {
				this.$store.commit('SET_TITLE', `Edit marktime ${this.timeOfMarktime}`)
				return true
			}
			return false
		},

		...mapState([
            'unsaved',
            'unsavedModal'
        ]),
		
		setup() {
            return {
                year: this.marktime.year,
                month: this.marktime.month
            };
		},

		timeOfMarktime() {
			return `${moment({ month: this.marktime.month }).format(
				"MMMM"
			)} / ${this.marktime.year}`;
		}
	},

	components: {
		MarktimeTable,
		MarktimeTableOverview,
		SimpleModal
	},

	methods: {
		updateMarktime() {

			this.updating = true;

			db
			.collection("marktimes")
			.doc(this.key)
			.update(this.marktime)
			.then(() => {
				this.updating = false;
				this.$toasted.show("Saved successfully!", {
					type: 'success'
				})

				this.$store.commit('SET_UNSAVED_MODAL', false);
				this.$store.commit('SET_UNSAVED', false);
				this.$store.commit('config/SET_ROUTE', null);

			})
			.catch(error => {
				this.updating = false;
				this.$toasted.show(`Error: ${error}`, {
					type: 'error'
				})
			});
		},

		discardChanges() {
            this.$store.commit('SET_UNSAVED_MODAL', false);
			this.$store.commit('SET_UNSAVED', false);
			if (this.$store.state.config.routeTo) {
				this.$router.replace({
					name: this.$store.state.config.routeTo
				})
			}
			this.$store.commit('config/SET_ROUTE', null);
        }
	},

	created() {
		db
		.collection('marktimes')
		.doc(this.$route.params.id)
		.get()
		.then(doc => {
			this.marktime = helper.mutateMarktime(doc.data())
		})

	},

	beforeRouteLeave: (to, from, next) => {
        if (store.state.unsaved) {
            store.commit('SET_UNSAVED_MODAL', true);
			store.commit('config/SET_ROUTE', to.name);
        } else {
            next();
        }
    }
};
</script>

